import { ReactNode } from 'react';

// currently the select and reveal component is only used for payment and delivery options
// if we need more options in the future, we can add more types here
export enum SelectAndRevealOptionType {
  DELIVERY = 'delivery',
  PAYMENT = 'payment',
}

export enum PaymentOption {
  PAY_IN_FULL = 'pay_in_full',
  PAY_IN_INSTALLMENTS = 'pay_in_installments',
}

export enum DeliveryOption {
  SHIP_TO_ME = 'ship_to_me',
  BOPIS = 'bopis',
}

export interface SelectOption {
  icon?: ReactNode;
  title?: string;
  subtext?: string;
  revealComponent?: JSX.Element;
  option?: DeliveryOption | PaymentOption;
  sideLabel?: string;
}

export interface OptionOverrides {
  title?: string;
  subtext?: string;
  icon?: ReactNode;
  sideLabel?: string;
}

export interface OptionParams {
  option: PaymentOption | DeliveryOption;
  overrides?: OptionOverrides;
}
